import type { ProductListItem } from 'types/capi/shared';

import {
  type ContractStockStatus,
  toContractStockStatus
} from '~/domain/stockStatus';

import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';

const NO_PRICE = -1;
const PRODUCT_CARD_SCHEMA_VERSION = 2;

export type ProductCardImpressionProperties = {
  module_position?: number;
  module_type?: string;
  position?: number;
  price_currency: string;
  price_regular: number;
  price_sale?: number;
  product_id: string;
  stock_status: ContractStockStatus;
};

type EventData = {
  guestId?: string;
  isBot: boolean;
  modulePosition?: number;
  moduleType?: string;
  position?: number;
  product: ProductListItem;
};

class ProductCardImpressionEvent extends ImpressionEvent<
  EventData,
  ProductCardImpressionProperties
> {
  protected get impressionType(): ImpressionType {
    return 'product_card';
  }

  protected get schemaVersion(): number {
    return PRODUCT_CARD_SCHEMA_VERSION;
  }

  protected getImpressionProperties(): ProductCardImpressionProperties {
    return {
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType,
      position: this.data.position,
      price_currency: this.data.product.price.currency,
      price_regular: this.data.product.price.regular ?? NO_PRICE,
      price_sale: this.data.product.price.sale ?? undefined,
      product_id: String(this.data.product.id),
      stock_status: toContractStockStatus(this.data.product.stock_status)
    };
  }
}

export default ProductCardImpressionEvent;
